<template>
  <div class="dialog-wrap">
    <el-dialog
      title="科目添加"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="780px">
      <el-form class="search-wrap" ref="searchForm" :inline="true" :model="query">
        <el-form-item label="科目名称" prop="keyword">
          <el-input v-model="query.keyword" size="mini" placeholder="输入科目名称/代码"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select style="width: 100px" v-model="query.status" size="mini" placeholder="请选择">
            <el-option
              v-for="item in filter.status"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="handleSearch">搜索</el-button>
          <el-button class="submit" size="mini" @click="handleFormReset('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        class="result"
        :data="results"
        tooltip-effect="dark"
        size="mini"
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center">
          </el-table-column>
          <el-table-column
            prop="name"
            label="科目名称"
            min-width="160"
            align="center">
          </el-table-column>
          <el-table-column
            prop="code"
            label="科目代码"
            min-width="160"
            align="center">
          </el-table-column>
          <el-table-column
            label="统考"
            width="160"
            align="center">
            <template slot-scope="scope">
              {{scope.row.type == 1 ? '统考' : '非统考'}}
            </template>
          </el-table-column>
          <el-table-column
            label="状态"
            width="120"
            align="center">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.status == 1?'success':'danger'"
              >{{scope.row.status == 1 ? '正常' : '下线'}}</el-tag>
            </template>
          </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination
          background
          small
          layout="total, prev, pager, next, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { majorSubjectUsableList, majorSubjectCreate } from '@/api/common'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    major: {
      type: Object,
      default: () => {return {}}
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      query:  {
        keyword: '',
        status: '',
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1
      },
      pageTotal: 10,
      filter: {
        status: [
          {label: '全部', value: ''},
          {label: '正常', value: '1'},
          {label: '关闭', value: '0'}
        ],
      },
      results: [],
      selections: []
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val

      if (val) {
        this.fetchMajorList()
      }
    }
  },
  methods: {
    // 科目列表请求
    fetchMajorList() {
      let params = {...this.query}
      params.major_id = this.major.id
      majorSubjectUsableList(params).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchMajorList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchMajorList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchMajorList()
    },
    // 选择
    handleSelectionChange(val) {
      this.selections = val
    },
    handleSubmit() {
      const params = {
        subjects: this.selections.map(item => ({subject_id: item.id, major_id: this.major.id}))
      }
      majorSubjectCreate(params).then(res => {
        this.$message.success(`添加成功`)
        this.$emit('submit')
        this.handleClose()
      }).catch(error => {
        console.log('error: ', error)
      })
    },
    handleClose() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
  .dialog-wrap {

    .search-wrap {
      margin-bottom: -18px;
    }
    .result {
      margin-top: 10px;
    }
    .footer {
      margin-top: 10px;
    }
  }
</style>
